<template>
  <div class="staff-queastion">
    <my-form
      :data="form"
      :option="option"
      page-key="edit"
      :footer-visible="true"
      width="auto"
      @submit="submit"
    />
  </div>
</template>

<script>
import MyForm from '@/components/myForm/index.vue'
import { staff } from '@/api/staff/index';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    MyForm,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    staffId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        disease: '',
        terminatedEmployment: '',
        convicted: '',
        bankrupt: '',
        relativesInMcc: '',
      },
    }
  },
  computed: {
    option() {
      return {
        columns: [
          {
            label: 'Have you been or are you suffering from any physical impairment, major medical condition, mental illness, or disease?',
            field: 'disease',
            formOption: {
              type: 'radio',
              dictData: [{ label: 'YES', value: '1' }, { label: 'NO', value: '2' }],
            },
          },
          {
            label: 'Have you ever been terminated or dismissed for the services of your previous employment? ',
            field: 'terminatedEmployment',
            formOption: {
              type: 'radio',
              dictData: [{ label: 'YES', value: '1' }, { label: 'NO', value: '2' }],
            },
          },
          {
            label: 'Have you been convicted in a Court of law in any country or any ongoing legal proceedings?',
            field: 'convicted',
            formOption: {
              type: 'radio',
              dictData: [{ label: 'YES', value: '1' }, { label: 'NO', value: '2' }],
            },
          },
          {
            label: 'Have you ever been declared a bankrupt?',
            field: 'bankrupt',
            formOption: {
              type: 'radio',
              dictData: [{ label: 'YES', value: '1' }, { label: 'NO', value: '2' }],
            },
          },
          {
            label: 'Do you have family members, relatives or friends working in MCC Group? ',
            field: 'relativesInMcc',
            formOption: {
              type: 'radio',
              dictData: [{ label: 'YES', value: '1' }, { label: 'NO', value: '2' }],
            },
          },
        ],
      }
    },
  },
  created() {
    const {
      disease, terminatedEmployment, convicted, bankrupt, relativesInMcc,
    } = this.data
    this.form = {
      disease: String(disease),
      terminatedEmployment: String(terminatedEmployment),
      convicted: String(convicted),
      bankrupt: String(bankrupt),
      relativesInMcc: String(relativesInMcc),
    }
    console.log(this.form, 'this.form');
  },
  methods: {
    submit(e) {
      const params = e
      params.id = this.staffId
      staff.staffUpdate(params).then(res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
.staff-queastion{
  .my-form{
    &>.row{
      height: 100px;
    }
  }
}
</style>
